/* global axios */
import ApiClient from './ApiClient';

class ViperConnectAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getEvolutionUrl(inboxId) {
    return `${this.url}/${inboxId}/evolution`;
  }

  // Create a new ViperConnect instance
  create(inboxId, settings = {}) {
    return axios.post(`${this.getEvolutionUrl(inboxId)}/create`, settings);
  }

  // Alias for create
  createInstance(inboxId, settings = {}) {
    return this.create(inboxId, settings);
  }

  // Get QR Code for connection
  getQrCode(inboxId) {
    return axios.get(`${this.getEvolutionUrl(inboxId)}/qr_code`);
  }

  // Get current status
  getStatus(inboxId) {
    return axios.get(`${this.getEvolutionUrl(inboxId)}/status`);
  }

  // Update settings
  updateSettings(inboxId, settings) {
    return axios.post(`${this.getEvolutionUrl(inboxId)}/settings`, settings);
  }

  // Test connection (force check)
  testConnection(inboxId) {
    return axios.post(`${this.getEvolutionUrl(inboxId)}/test`);
  }

  // Disconnect and delete instance
  disconnect(inboxId) {
    return axios.delete(`${this.getEvolutionUrl(inboxId)}/disconnect`);
  }

  // Get connection logs
  getLogs(inboxId) {
    return axios.get(`${this.getEvolutionUrl(inboxId)}/logs`);
  }
}

export default new ViperConnectAPI();

